/*---------------------------------------------------------------------------------------------
Program     :  MainService.js
Description :  MainService  program for Map and track. 
Date        :  29/08/2024
Created By  :  Fode/Jelbin
---------------------------------------------------------------------------------------------
TicketNo         Author          Date            ChangeDesc
---------------------------------------------------------------------------------------------
29082024        Fode/Jelbin     -  29/08/2024        Created
---------------------------------------------------------------------------------------------*/
import axios from "axios";
import AuthHeader from "./AuthHeader";
import { WEBSOCKET_URL } from "../components/Socketconfig";
import io from 'socket.io-client';


class MainService {

  constructor() {
    this.socket = io(WEBSOCKET_URL);
    this.setupSocketListeners();
  }

  setupSocketListeners() {
    this.socket.on('connect', () => {
      console.log('Connected to WebSocket server');
    });

    this.socket.on('disconnect', () => {
      console.log('Disconnected from WebSocket server');
    });
  }

  selectSourceAndDate(source, dateRange,userName) {
    console.log("serivce socket emit",source, dateRange,userName);
    this.socket.emit('select_source_and_date', { source, dateRange,userName });
  }

  onUserNotification(callback) {
    this.socket.on('user_notification', callback);
  }

  getCompanyData() {
    return axios.get(`/mapandtrack/getCompanyData`, {
      headers: AuthHeader(),
    });
  }

  getMainSource() {
    return axios.get(`/mapandtrack/getMainSource`, {
      headers: AuthHeader(),
    });
  }
   
  getTravelTimeConstant() {
    return axios.get(`/mapandtrack/getTravelTimeConstant`, {
      headers: AuthHeader(),
    });
  }
  
  getsearchdata(zformName, zfromDate, ztoDate, zuniquefield,ZFILTERBYFIELDArray) {
    return axios.get(`/mapandtrack/getsearchdata/${zformName}/${zfromDate}/${ztoDate}/${zuniquefield}/${encodeURIComponent(JSON.stringify(ZFILTERBYFIELDArray))}`, {  
      headers: AuthHeader(),
    });
  }

  /*FKS get traveller based on selected source*/
  gettravelMainSource(zmapname/*zformName*/) {
    return axios.get(`/mapandtrack/gettravelMainSource/${zmapname/*zformName*/}`, {
      headers: AuthHeader(),
    });
  }

  gettravellerData(zmapName/*zformName*/) {
    return axios.get(`/mapandtrack/gettravellerData/${zmapName}`, {
      headers: AuthHeader(),
    });
  }
  
  getAlternatetrvlHdr(zmapname) {
    return axios.get(`/mapandtrack/getAlternatetrvlHdr/${zmapname}`, {
      headers: AuthHeader(),
    });
  }

  /*Holiday Source*/
  getHolidaysource(zmapName) {
    return axios.get(`/mapandtrack/getholidaySource/${zmapName}`, {
      headers: AuthHeader(),
    });
  }

  /*Holiday details*/
  getholidayDetails(zfromDate,ztoDate,zholidayformname,zfromdtfld,ztodtfld) {
    return axios.get(`/mapandtrack/getholidayDetails/${zfromDate}/${ztoDate}/${zholidayformname}/${zfromdtfld}/${ztodtfld}`, {
      headers: AuthHeader(),
    });
  }

  getAlternatetrvldata(zfromDate,ztoDate,zmapName) {
    return axios.get(`/mapandtrack/getAlternatetrvldata/${zfromDate}/${ztoDate}/${zmapName}`, {
      headers: AuthHeader(),
    });
  }

  getparticipantsData(zmapName) {
    return axios.get(`/mapandtrack/getparticipantsdata/${zmapName}`, {
      headers: AuthHeader(),
    });
  }
  
  getDistanceMatrix(originval, destval) {
    return axios.post("/mapandtrack/distance-matrix", {
      origins: originval,
      destinations: destval
    }, {
      headers: AuthHeader(),
    });
  }
  
  getPOIsource(zmapName/*zformName*/) {
    return axios.get(`/mapandtrack/getpoiSource/${zmapName}`, {
      headers: AuthHeader(),
    });
  }

  // getPOIData(zpoiename,zpoifields) {
  //   return axios.get(`/mapandtrack/getpoisourceData/${zpoiename}/${zpoifields}`, {
  //     headers: AuthHeader(),
  //   });
  // }

  getPOIData(zpoiename,zpoifields,ZPOIFILTERARRAY) {
    return axios.get(`/mapandtrack/getpoisourceData/${zpoiename}/${zpoifields}/${encodeURIComponent(JSON.stringify(ZPOIFILTERARRAY))}`, {
      headers: AuthHeader(),
    });
  }
  
  getFinalTravelData(zmapName,zfromDate,ztoDate) {
    return axios.get(`/mapandtrack/getFinalTravelData/${zmapName}/${zfromDate}/${ztoDate}`, {
      headers: AuthHeader(),
    });
  }
  
  getNoteData(mainFormName,subformName,ZrecordUniqueVal) {
    return axios.get(`/mapandtrack/getnotedata/${mainFormName}/${subformName}/${ZrecordUniqueVal}`, {
      headers: AuthHeader(),
    });
  }

  patchData(data,ZDATERANGE, selectedtraveler,tableUniqueName,selectedSourceMain,fieldPOIsave,startTimeField,endTimeField,
    tskTravelTimeField,durationFieldsY,selectedSourceMapname,selectedChooseData,subformName,
    participantsFields,participantsTimeFields,tsktrvlTimeFldBkup,leadFinalTravelTimesPayload,FinalTravelTimestoDeleteLead,
    participantsFinlTrvlTimeFinal,FinalTravelTimestoDeleteParticipant) {
    const url = `/mapandtrack/patchData?ZDATERANGE=${encodeURIComponent(ZDATERANGE)}&selectedtraveler=${encodeURIComponent(selectedtraveler)} 
    &tableUniqueName=${encodeURIComponent(tableUniqueName)}&selectedSourceMain=${encodeURIComponent(selectedSourceMain)}&fieldPOIsave=${encodeURIComponent(fieldPOIsave)}
    &startTimeField=${encodeURIComponent(startTimeField)}&endTimeField=${encodeURIComponent(endTimeField)}&tskTravelTimeField=${encodeURIComponent(tskTravelTimeField)}
    &durationFieldsY=${encodeURIComponent(durationFieldsY)}&selectedSourceMapname=${encodeURIComponent(selectedSourceMapname)}
    &selectedChooseData=${encodeURIComponent(JSON.stringify(selectedChooseData))}&subformName=${encodeURIComponent(subformName)}
    &participantsFields=${encodeURIComponent(participantsFields)}&participantsTimeFields=${encodeURIComponent(participantsTimeFields)}
    &tsktrvlTimeFldBkup=${encodeURIComponent(tsktrvlTimeFldBkup)}`; 

    const requestData = {
      combinedData : data,
      leadFinalTravelTimesPayload:leadFinalTravelTimesPayload,
      finalTraveltoDeleteLead: FinalTravelTimestoDeleteLead,
      participantsFinlTrvlTimeFinal:participantsFinlTrvlTimeFinal,
      FinalTravelTimestoDeleteParticipant:FinalTravelTimestoDeleteParticipant
    };
    
    return axios.post(url, requestData, {
      headers: AuthHeader(),
    });
  }
  
  getCoordinates(formattedAddress) {
    return axios.get(`/mapandtrack/getCoordinates/${formattedAddress}`, {
      headers: AuthHeader(),
    });
  }

  postCoordinates(payloadCoordinates) {
    return axios.post(`/mapandtrack/postCoordinates`,payloadCoordinates, {
      headers: {
        ...AuthHeader(),
        "Content-Type": "application/json",
      },
    });
  }
}

export default new MainService();
